import {
  MenuItemType,
  CartItemType,
  NotificationType,
} from "@/components/layouts/types";

export const menuItems: MenuItemType[] = [
  {
    label: "Dashboard",
    icon: "ph-house",
    link: "/dashboard",
    id: "dashboard",
  },
  {
    label: "Replacements",
    icon: "ph-package",
    link: "/replacements",
    id: "replacements",
    moduleKey: "replacements",
  },
  {
    label: "Patients",
    icon: "ph-user",
    link: "/patients",
    id: "patients",
    moduleKey: "copay",
  },
  {
    label: "Orders",
    icon: "ph-package",
    link: "/orders",
    id: "orders",
    moduleKey: "orders",
  },
  {
    label: "Claims",
    icon: "ph-clipboard-text",
    link: "/claims",
    id: "claims",
    moduleKey: "copay",
  },
  {
    label: "Practices",
    icon: "ph-circles-four",
    link: "/practices",
    id: "practices",
    moduleKey: "copay",
  },
  {
    label: "Users",
    icon: "ph-users",
    link: "/users",
    id: "users",
    adminOnly: true,
  },
  {
    label: "Settings",
    icon: "ph-gear-six",
    link: "/settings",
    id: "settings",
    caravelOnly: true,
  },
];

export const cartItems: CartItemType[] = [];

export const notifications: NotificationType[] = [];

export const visibleMenuItemsFor = (
  enabledModuleKeys: string[] = [],
  isAdminUser = false,
  isCaravelAdmin = false
): MenuItemType[] => {
  return menuItems.filter((menuItem) => {
    if (menuItem.moduleKey && !enabledModuleKeys.includes(menuItem.moduleKey)) {
      return false;
    }

    if (menuItem.adminOnly && !isAdminUser) {
      return false;
    }

    if (menuItem.caravelOnly && !isCaravelAdmin) {
      return false;
    }

    return true;
  });
};
